<template>
  <div class="official-website">
    <div class="img-box">
      <div class="tip-version">专注青少年体育培训</div>
      <img src="@/assets/images/office_all_img.jpg">
      <div class="content-box">
        <div class="trial-box">
          <div class="title-name">申请试用 领取优惠</div>
          <input type="text" placeholder="输入您的手机号" v-model="form.phone" class="phone">
          <van-field
            v-model="form.smsCode"
            center
            type="tel"
            placeholder="短信验证码"
            class="code-name"
            :error-message="form.smsCodeMsg">
            <template slot="button" >
              <div class="get-code" >
                <van-button size="small" custom-class="set-code" type="primary"  @click="sendSmsCode" >{{ sendCodeLabel }}</van-button>
              </div>
            </template>
          </van-field>
          <div  @click="showPickerHandler()">
            <van-field
              :value="form.displayCity"
              readonly
              clickable
              class="city-style"
              input-align="right"
              right-icon="arrow"
              label="城市"
              placeholder="请选择"/>
          </div>
          <div class="btn-submit" @click="submitForm"><div>提交</div></div>
        </div>
        <!-- 选择城市 start -->
        <van-popup v-model="showCityPicker" style="height: 350px" position="bottom" @click="onCityHide">
          <van-picker
            show-toolbar
            :columns="areaList"
            value-key="name"
            active-class="picker-active"
            :loading="loadCityData"
            @change="onCityChange"
            @cancel="showCityPicker = false"
            @confirm="onCityConfirm" />
        </van-popup>
        <!-- 选择城市 end -->
      </div>
      <div class="content-box-ext">
        <span class="txt-link" @click="goExtLink('icp')">沪ICP备15013331号-3</span>
        <span class="txt-link" @click="goExtLink('wang')">沪公网安备 31010702003720号</span>
      </div>
    </div>
  </div>
</template>

<script>
import {Toast} from 'vant'
import { getVerifyCode, applyService, getAreaTreeList } from '@/api/team'
import { ImageFormat } from '@/utils'
import { RegExpr } from '@/utils/regex'
const TIME_COUNT = 60
const beforeSend = '发送验证码'
const afterSend = 's后发送'
export default {
  name: 'officialWebsite',
  data() {
    return {
      timer: null,
      sendCodeLabel: beforeSend,
      count: TIME_COUNT,
      form: {
        phone: '',
        smsCode: '',
        smsCodeMsg: '',
        displayCity: '',
        submitCity: ''
      },
      showCityPicker: false,
      areaList: [],
      loadCityData: true
    }
  },
  created() {
    this.getShare()
  },
  mounted() {
    this.trackingTD('page_cb_miniSite')
  },
  methods: {
    // 发送验证码
    sendSmsCode () {
      if (!RegExpr.checkMobile(this.form.phone)) {
        Toast('请输入正确的手机号')
        return
      }
      if (this.timer) return
      const params = {
        mobile: this.form.phone
      }
      getVerifyCode(params).then(res => {
        if (res) {
          Toast('发送成功')
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--
              this.sendCodeLabel = this.count + afterSend
            } else {
              this.show = true
              clearInterval(this.timer)
              this.timer = null
              this.sendCodeLabel = beforeSend
              this.count = TIME_COUNT
            }
          }, 1000)
        }
      })
    },
    // 提交
    submitForm () {
      const params = {
        mobile: this.form.phone,
        code: this.form.smsCode,
        type: 0,
        area: this.form.submitCity
      }
      if (!RegExpr.checkMobile(this.form.phone)) {
        Toast('请输入正确的手机号')
        return
      }
      if (!this.form.smsCode) {
        Toast('请输入正确的验证码')
        return
      }
      applyService(params).then(res => {
        if (res) {
          Toast('申请试用成功')
          this.$router.push({ name: 'officialSuccess', query: { type: 'official' } })
        }
      })
    },
    // 选择城市
    showPickerHandler () {
      this.showCityPicker = true
      this.getCity()
    },
    getCity () {
      getAreaTreeList().then(res => {
        const listStr = res.data.list.replace(/'/g, '"')
        const list = JSON.parse(listStr)
        this.areaList = [
          {
            values: list,
            className: 'column1',
            defaultIndex: 0
          },
          {
            values: list[0].kids.map(c => c.name),
            className: 'column2',
            defaultIndex: 0
          },
          {
            values: list[0].kids[0].kids.map(c => c.name),
            className: 'column3',
            defaultIndex: 0
          }
        ]
        this.loadCityData = false
      })
    },
    onCityChange (picker, value, colum) {
      if (colum === 0) {
        const cityList = value[0].kids
        const cityArr = cityList.map(item => item.name)
        const countryList = cityList[0].kids
        const countryArr = countryList.map(item => item.name)
        picker.setColumnValues(1, cityArr)
        picker.setColumnValues(2, countryArr)
      } else if (colum === 1) {
        const cityList = value[0].kids
        const city = cityList.find(item => item.name === value[1])
        // const cityArr = cityList.map(item => item.name)
        const countryList = city.kids
        const countryArr = countryList.map(item => item.name)
        picker.setColumnValues(2, countryArr)
      }
    },
    onCityConfirm (value, colum) { // city picker
      const province = value[0]
      const city = province.kids[colum[1]]
      if (city.kids.length > 0) {
        const country = city.kids[colum[2]]
        this.form.displayCity = [province.name, city.name, country.name].join('|')
        this.form.submitCity = [province.name, city.name, country.name].join('')
      } else {
        this.form.displayCity = [province.name, city.name].join('|')
        this.form.submitCity = [province.name, city.name].join('')
      }
      this.showCityPicker = false
    },
    onCityHide () {
      this.showCityPicker = false
    },
    //  分享
    getShare() {
      const url = this.getShareLink()
      this.shareData = {
        title: '排课点评好方便，青训就用邦教练',
        link: url,
        image: ImageFormat.squareImageView('FhKR44j0yKjTf90nJpehAal_T7hM', 120),
        abstract: '专为线下体培机构量身打造的「教务管理+家校互动」云平台'
      }
      this.wxShare(this.shareData)
    },
    goExtLink(name) {
      if (name === 'icp') {
        window.location.href = 'https://beian.miit.gov.cn'
      } else if (name === 'wang') {
        window.location.href = 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010702003720'
      }
    },
    getShareLink: function () {
      const arr = window.location.href
      return arr
    }
  }
}
</script>

<style lang="scss">
  .official-website{
    .img-box{
      position: relative;
      .tip-version{
        color: #ffffff;
        font-size: 14px;
        position: absolute;
        top: 7px;
        z-index: 99;
        box-sizing: border-box;
        margin-top: 7px;
        opacity: 0.5;
        left: 50%;
        transform: translateX(-50%);
      }
      img{
        width: 100%;
        display: block;
        position: relative;
        top: 0;
        left: 0;
      }
      .content-box{
        width: 375px;
      }
      .trial-box{
        width: 333px;
        height: 295px;
        background: #ffffff;
        border-radius: 10px;
        position: absolute;
        bottom: 120px;
        left: 50%;
        transform: translateX(-50%);
        padding: 16px 22px;
        box-sizing: border-box;
        box-shadow:0px 0px 14px 0px rgba(197,198,249,1)inset;
        .title-name{
          text-align: center;
          font-size: 20px;
          color: #1217BF;
          margin-bottom: 15px;
        }
        /*input{*/

        /*}*/
        .phone{
          width: 290px;
          font-size: 16px;
          height: 44px;
          background: #F5F6F9;
          border: 0;
          border-radius: 5px;
          padding-left: 15px;
          box-sizing: border-box;
        }
        .dis-flex{
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 10px;
          .code{
            width: 190px;
            font-size: 16px;
          }
          .set-code{
            width: 90px;
            height: 44px;
            line-height: 44px;
            background: #F5F6F9;
            border: 0;
            border-radius: 5px;
            padding-left: 9px;
            box-sizing: border-box;
            font-size: 14px;
            color: #1217BF;
          }
        }
        .get-code .van-button--primary {
          width: 90px;
          height: 44px;
          line-height: 44px;
          background: #F5F6F9;
          border: 0;
          border-radius: 5px;
          padding-left: 9px;
          box-sizing: border-box;
          font-size: 14px;
          color: #1217BF;
        }
        .city-style{
          width: 290px;
          height: 44px;
          background: #F5F6F9;
          border-radius: 5px;
          padding-left: 15px;
          margin-top: 10px;
          font-size: 16px;
          &:after {
            border-bottom: 0;
          }
        }
        .code-name{
          padding: 0;
          margin-top: 10px;
          font-size: 18px;
          &:after {
            border-bottom: 0;
          }
          input{
            width: 190px;
            font-size: 16px;
            height: 44px;
            background: #F5F6F9;
            border: 0;
            border-radius: 5px;
            padding-left: 15px;
            box-sizing: border-box;
          }
        }
        .btn-submit{
          width: 290px;
          height: 44px;
          line-height: 44px;
          background: #1217BF;
          border: 0;
          border-radius: 5px;
          padding-left: 15px;
          box-sizing: border-box;
          font-size: 16px;
          color: #ffffff;
          margin-top: 16px;
          text-align: center;
          box-shadow:0px 0px 12px 0px rgba(255,255,255,0.5) inset;
        }
      }
    }
    input::-webkit-input-placeholder {
      font-size: 16px;
      color: #8D90AE;
    }
    .van-popup--bottom{
      bottom: -72px !important;
    }
    .content-box-ext {
      font-size: 12px;
      background-color: rgb(54,5,211);
      color: #FFFFFF;
      display: flex;
      justify-content: space-around;
      padding: 16px;
      .txt-link {

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/official-website/index.vue